module.exports = __webpack_public_path__ + "img/close.b176a09.svg";